import { Logger } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'

const logger = new Logger('AuthRouter')

const state = {
    user: null,
    userId: null,
    attributes: {},
    updateform: {},
    userVerification: [],
    tempusername: '',
    redirectPath: '',
    signUpRedirectPath: ''
}

// getters
const getters = {
    user: state => state.user,
    userId: state => state.userId,
    session: state => state.user ? state.user.signInUserSession : {},
    attributes: state => state.attributes,
    userVerification: state => state.userVerification,
    redirectPath: state => state.redirectPath,
    signUpRedirectPath: state => state.signUpRedirectPath,
    tempusername: state => state.tempusername
}

// actions
const actions = {
    fetchUser ({ commit }) {
        return new Promise((resolve, reject) => {
            Auth.currentAuthenticatedUser().then(user => {
                logger.debug('...has user', user)
                commit('setUser', user)
                commit('tempUserName', user.username)
                Auth.currentCredentials().then(credentials => {
                    commit('setUserId', credentials.identityId)
                }).catch(err => {
                    commit('setUserId', null)
                    logger.debug('get current credentials err', err)
                })

                Auth.userAttributes(user).then(results => {
                    commit('setAttributes', results.reduce((obj, item) => ({ ...obj, ...{ [item.Name]: item.Value } }), {}))
                    resolve()
                }).catch(() => commit('setAttributes', {}))
            }).catch((err) => {
                logger.debug('...no user', err)
                commit('setUser', {})
                commit('setUserId', null)
                commit('setAttributes', {})
                reject(err)
            })
        })
    },

    signOut () {
        return Auth.signOut().catch(e => e)
    },

    setRedirectPath ({ commit }, path) {
        commit('setRedirectPath', path)
    },

    setSignUpRedirectPath ({ commit }, path) {
        commit('setSignUpRedirectPath', path)
    }
}

// mutations
const mutations = {
    setUser (state, user) {
        state.user = user
    },
    setUserId (state, userId) {
        state.userId = userId
    },
    setAttributes (state, attributes) {
        state.attributes = attributes
        state.user.attributes = attributes
    },
    setUserVerification (state, data) {
        state.userVerification = data
    },
    updateAttributes (state, updateform) {
        if (updateform.given_name) state.attributes.given_name = updateform.given_name
        if (updateform.family_name) state.attributes.family_name = updateform.family_name
        if (updateform.email) state.attributes.email = updateform.email
        if (updateform.email_verified !== undefined) state.attributes.email_verified = updateform.email_verified
    },
    tempUserName (state, tempusername) {
        state.tempusername = tempusername
    },
    setRedirectPath (state, path) {
        state.redirectPath = path
    },
    setSignUpRedirectPath (state, path) {
        state.signUpRedirectPath = path
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
